import { render } from "./OrderPicture.vue?vue&type=template&id=04e9316a&scoped=true"
import script from "./OrderPicture.vue?vue&type=script&lang=js"
export * from "./OrderPicture.vue?vue&type=script&lang=js"

import "./OrderPicture.vue?vue&type=style&index=0&id=04e9316a&scoped=true&lang=css"

import exportComponent from "/Users/dejth/Workspace/nakee-order-detail/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e9316a"]])

export default __exports__